var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region RecurringInvoice - Ctor 

    ns.RecurringInvoice = function RecurringInvoice($translate) {

        // from InvoiceBase
        this.resetFields();
        if ($translate) {
            this.initLocalization($translate);
        }

        this.invoiceLineKindergartenLunchQty = 0;
        this.invoiceLineKindergartenSnackQty = 0;
    }

    // #endregion

    // #region InvoiceBase - Inheritance

    ns.RecurringInvoice.prototype = new ns.InvoiceBase(true);
    ns.RecurringInvoice.prototype.constructor = ns.InvoiceBase;
    ns.RecurringInvoice.prototype.parent = ns.InvoiceBase.prototype;

    // #endregion

    // #region RecurringInvoice - Methods

    ns.RecurringInvoice.prototype.getDTO = function ($translate) {

        var res = this.getInvoiceDTO($translate);

        res.invoiceTemplateID = this.invoiceTemplateID;
        res.paymentReferenceNumber = this.paymentReferenceNumber;

        return res;
    }

    ns.RecurringInvoice.prototype.initData = function (dto) {

        this.initDataByInvoiceDTO(dto);

        this.invoiceTemplateID = dto.invoiceTemplateID;
        this.paymentReferenceNumber = dto.paymentReferenceNumber;        
        this.studentID = dto.customerStudentID;
    }

    // #endregion

}(webooker_acivity_models));